__turbopack_context__.v({
  "checkbox": "moveStageModal-module-scss-module__ToTDIW__checkbox",
  "modal": "moveStageModal-module-scss-module__ToTDIW__modal",
  "modalContent": "moveStageModal-module-scss-module__ToTDIW__modalContent",
  "note": "moveStageModal-module-scss-module__ToTDIW__note",
});
